import { render, staticRenderFns } from "./UpdatePersonInfo.vue?vue&type=template&id=0a12cea0&"
import script from "./UpdatePersonInfo.vue?vue&type=script&lang=js&"
export * from "./UpdatePersonInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports